<template>
	<SOSlotModal
		:modal-title="'Hasil Ekspor'"
		:modal-id="id"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="f-regular f-12 f-c-midgrey p-x-20 p-y-8 border-bottom">
				Karena data terlalu banyak, maka hasil ekspor dibagi menjadi beberapa file.
			</div>
			<div style="max-height: 300px; overflow: auto">
				<div class="d-flex-between-center align-items-center p-x-20 p-y-12 border-bottom"
				     v-for="(data, i) in exportData" :key="i"
				>
					<div class="d-block" style="max-width: 60%">
						<div class="f-regular f-16 f-c-black">
							{{ data.filename }}
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							Diekspor {{ data.time_to_life }}
						</div>
					</div>
					<button v-if="!data.downloaded" class="btn btn-primary" @click="download(data, i)" :id="`d${i}`">
						<img src="@/assets/icons/download-white.svg" alt=""> Download
					</button>
					<button v-else class="btn btn-primary btn-secondary" disabled>
						Telah didownload
					</button>
				</div>
			</div>
		</template>

		<template v-slot:modal-footer v-if="false">
		</template>
	</SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOModalExport",
	components: {
		SOButton,
		SOInputSelect,
		SOSlotModal,
	},
	props: {
		exportData: Array,
		deleteClusterActions: String,
		deleteMasterActions: String,
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	data() {
		return {
			id: "modal-ekspor-multiple-file",
			downloadedFile: 0,
		}
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		download(data, i) {
			const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
			if (this.isWebview() && flutterConfig.platform !== 'web') {
				this.flutterDownload(data.fileurl);
			} else {
				window.open(data.fileurl, '_blank');
			}
			$("#d" + i).addClass("btn-secondary").removeClass("btn-primary").html("Telah didownload").prop("disabled", true)
			this.downloadedFile++
			this.$emit("downloaded", i)

			// DELETE PER FILE
			this.deleteExportCluster(data.key_redis_cluster)
			if (this.exportData.length === this.downloadedFile) {
				this.deleteExportMaster()
				this.close()
				this.$emit("done")
			}

			// DELETE ALL FILE
			// if (this.exportData.length === this.downloadedFile) {
			// 	// this.deleteExportCluster(data)
			// 	this.deleteExportMaster(data)
			// 	this.close()
			// 	this.$emit("done")
			// }
		},
		async deleteExportCluster(key) {
			await this.$store.dispatch(this.deleteClusterActions, key)
		},
		async deleteExportMaster() {
			await this.$store.dispatch(this.deleteMasterActions)
		},
	}
}
</script>